export default "__VITE_ASSET__563c1eb3__"